(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.messages = Array.from(this.querySelectorAll('.announcement-bar__message'));
      this.index = this.messages.findIndex((message) => !message.hidden);
      if (this.index < 0) this.index = 0;
      this.messages.forEach((message, i) => {
        message.hidden = i !== this.index;
        message.classList.toggle('is-active', i === this.index);
      });

      this.prevButton = this.querySelector('.announcement-bar__nav--prev');
      this.nextButton = this.querySelector('.announcement-bar__nav--next');
      this.prevButton?.addEventListener('click', () => this.step(-1));
      this.nextButton?.addEventListener('click', () => this.step(1));

      const autoplayMs = Number(this.dataset.autoplayMs);
      if (autoplayMs > 0 && this.messages.length > 1) {
        this.timer = setInterval(() => this.step(1), autoplayMs);
      }
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    // Slides the outgoing message out one side while the incoming message
    // slides in from the other, both absolutely stacked in the same box
    // (see .announcement-bar__message's position: absolute; inset: 0).
    // The incoming message starts hidden (display: none), so its
    // off-screen position has to be committed via a forced reflow before
    // switching to is-active, or the two style changes coalesce into one
    // and there's nothing for the transition to animate between.
    step(delta) {
      if (this.messages.length < 2 || this.animating) return;

      const outgoing = this.messages[this.index];
      this.index = (this.index + delta + this.messages.length) % this.messages.length;
      const incoming = this.messages[this.index];

      const outClass = delta > 0 ? 'is-prev' : 'is-next';
      const inClass = delta > 0 ? 'is-next' : 'is-prev';

      this.animating = true;
      incoming.classList.remove('is-active', 'is-prev', 'is-next');
      incoming.hidden = false;
      incoming.classList.add(inClass);
      void incoming.offsetWidth;
      incoming.classList.remove(inClass);
      incoming.classList.add('is-active');
      outgoing.classList.remove('is-active', 'is-prev', 'is-next');
      outgoing.classList.add(outClass);

      // Runs exactly once per step: whichever of transitionend / the timeout
      // fallback comes first wins. Without the guard, a late second call
      // could hide a message that a newer step() had already made active,
      // leaving the bar blank. transitionend bubbles (from links inside the
      // message, and fires once per transitioned property), so only the
      // incoming message's own event counts.
      let finished = false;
      const onTransitionEnd = (event) => {
        if (event.target === incoming) finish();
      };
      const finish = () => {
        if (finished) return;
        finished = true;
        clearTimeout(fallback);
        incoming.removeEventListener('transitionend', onTransitionEnd);
        outgoing.classList.remove('is-prev', 'is-next');
        if (outgoing !== this.messages[this.index]) outgoing.hidden = true;
        this.animating = false;
      };
      incoming.addEventListener('transitionend', onTransitionEnd);
      const fallback = setTimeout(finish, 550);
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    const dialog = document.getElementById('cart-drawer');
    if (!dialog) return;

    const sectionId = dialog.dataset.sectionId;
    const cartUrl = dialog.dataset.cartUrl;
    const recommendationsBase = dialog.dataset.recommendationsBase;
    const errorEl = dialog.querySelector('[data-cart-drawer-error]');
    const liveEl = dialog.querySelector('[data-cart-drawer-live]');

    // Stepper state: lineKey -> quantity the shopper wants. Clicks update it
    // (and the visible number) immediately; a single serial queue sends the
    // latest target per line, so rapid clicks can't race each other.
    const targets = new Map();
    let queueRunning = false;
    // Ordering: every request (refresh GET or stepper POST) takes a sequence
    // number when it is *sent*. A response is only applied if it was sent
    // after whatever is currently on screen, so a slow older response can
    // never overwrite newer state, whichever code path produced it.
    let requestSeq = 0;
    let appliedSeq = 0;
    // `.is-loading` is driven by a counter of in-flight refreshes (always
    // decremented in `finally`), not by "whoever owns the latest token", so
    // it can never be left on after a refresh gets superseded.
    let loadingCount = 0;
    // A refresh sent while a stepper POST is in flight may be answered from
    // cart state that predates that POST, so it can't be trusted: the queue
    // resyncs once more after it drains.
    let resyncAfterQueue = false;
    let announceTimer = null;
    const REFRESH_TIMEOUT_MS = 15000;

    function routesRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function applyFragment(doc, selector) {
      const fresh = doc.querySelector(selector);
      const live = document.querySelector(selector);
      if (fresh && live) live.replaceWith(fresh);
    }

    function syncHeaderCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.hidden = count === 0;
      });
    }

    function showError(message) {
      if (errorEl) errorEl.textContent = message || dialog.dataset.errorLabel;
    }

    function clearError() {
      if (errorEl) errorEl.textContent = '';
    }

    function captureFocus() {
      const active = document.activeElement;
      if (!active || !dialog.contains(active)) return null;
      const stepper = active.closest('[data-qty-increase], [data-qty-decrease]');
      if (!stepper) return null;
      return {
        key: stepper.dataset.lineKey,
        attr: stepper.hasAttribute('data-qty-increase') ? 'data-qty-increase' : 'data-qty-decrease',
      };
    }

    /** The fragment swap replaces the focused stepper button with a fresh
        copy; put focus back on the same control (or the nearest sensible
        one if its line was removed) so keyboard users keep their place. */
    function restoreFocus(saved) {
      if (!saved || !dialog.open) return;
      const escapedKey = window.CSS && CSS.escape ? CSS.escape(saved.key) : saved.key;
      const target =
        dialog.querySelector(`[${saved.attr}][data-line-key="${escapedKey}"]`) ||
        dialog.querySelector('[data-qty-decrease], [data-qty-increase]') ||
        dialog.querySelector('[data-dialog-close]');
      if (target) target.focus();
    }

    function reapplyPendingTargets() {
      targets.forEach((quantity, key) => {
        const escapedKey = window.CSS && CSS.escape ? CSS.escape(key) : key;
        const line = dialog.querySelector(`[data-cart-line][data-line-key="${escapedKey}"]`);
        const qtyEl = line && line.querySelector('[data-qty-value]');
        if (qtyEl) qtyEl.textContent = quantity;
        if (line) line.classList.add('is-pending');
      });
    }

    function announce() {
      const source = dialog.querySelector('[data-cart-drawer-live-source]');
      if (!liveEl || !source) return;
      const message = source.textContent.trim();
      // Clear, then set on a later task: setting identical text in the same
      // tick is not a DOM change, so screen readers would skip a repeat total.
      clearTimeout(announceTimer);
      liveEl.textContent = '';
      announceTimer = setTimeout(() => {
        liveEl.textContent = message;
      }, 120);
    }

    function applySectionHtml(html, options) {
      options = options || {};
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const focus = captureFocus();
      applyFragment(doc, '[data-cart-drawer-shipping]');
      applyFragment(doc, '[data-cart-drawer-items]');
      applyFragment(doc, '[data-cart-drawer-footer]');
      reapplyPendingTargets();
      restoreFocus(focus);
      if (options.announce) announce();
    }

    async function refreshUpsell(cartData) {
      const upsell = document.querySelector('[data-cart-drawer-upsell]');
      if (!upsell) return;
      if (!cartData.items || cartData.items.length === 0 || !recommendationsBase) {
        upsell.innerHTML = '';
        return;
      }
      try {
        const upsellRes = await fetch(recommendationsBase + '&product_id=' + cartData.items[0].product_id);
        const upsellHtml = await upsellRes.text();
        const upsellDoc = new DOMParser().parseFromString(upsellHtml, 'text/html');
        applyFragment(upsellDoc, '[data-cart-drawer-upsell]');
      } catch (error) {}
    }

    function setLoading(delta) {
      loadingCount = Math.max(0, loadingCount + delta);
      dialog.classList.toggle('is-loading', loadingCount > 0);
    }

    async function refreshCartDrawer(options) {
      options = options || {};
      const seq = ++requestSeq;
      if (queueRunning) resyncAfterQueue = true;
      setLoading(1);
      const controller = window.AbortController ? new AbortController() : null;
      const timeout = controller ? setTimeout(() => controller.abort(), REFRESH_TIMEOUT_MS) : null;
      const signal = controller ? controller.signal : undefined;

      try {
        const [cartRes, sectionRes] = await Promise.all([
          fetch(routesRoot() + 'cart.js', { headers: { Accept: 'application/json' }, signal: signal }),
          fetch(cartUrl + '?section_id=' + encodeURIComponent(sectionId), { signal: signal }),
        ]);
        if (!cartRes.ok || !sectionRes.ok) throw new Error('cart refresh failed');
        const cartData = await cartRes.json();
        const sectionHtml = await sectionRes.text();

        if (seq > appliedSeq) {
          appliedSeq = seq;
          applySectionHtml(sectionHtml, options);
          syncHeaderCount(cartData.item_count);
          refreshUpsell(cartData);
        }
      } catch (error) {
        // Leave existing drawer content in place on a network failure/timeout.
      } finally {
        clearTimeout(timeout);
        setLoading(-1);
      }

      if (options.open) window.openDialogAnimated(dialog);
    }

    async function postChange(lineKey, quantity) {
      const response = await fetch(routesRoot() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: lineKey,
          quantity: quantity,
          sections: [sectionId],
          sections_url: window.location.pathname,
        }),
      });
      let data = null;
      try {
        data = await response.json();
      } catch (error) {}
      return { ok: response.ok && !!data, data: data };
    }

    async function runQueue() {
      if (queueRunning) return;
      queueRunning = true;
      dialog.classList.add('is-updating');

      let lastCart = null;
      let lastSeq = 0;
      let failed = false;

      while (targets.size > 0) {
        const [lineKey, quantity] = targets.entries().next().value;
        let result;
        const seq = ++requestSeq;
        try {
          result = await postChange(lineKey, quantity);
        } catch (error) {
          result = { ok: false, data: null };
        }

        if (result.ok) {
          lastCart = result.data;
          lastSeq = seq;
          // A newer click for this line arrived while the request was in
          // flight: keep the entry so the loop sends the newer target.
          if (targets.get(lineKey) === quantity) targets.delete(lineKey);
        } else {
          failed = true;
          targets.delete(lineKey);
          const data = result.data || {};
          showError(data.description || data.message);
        }
      }

      queueRunning = false;
      dialog.classList.remove('is-updating');

      const html = lastCart && lastCart.sections && lastCart.sections[sectionId];
      const needsResync = failed || !html || resyncAfterQueue || lastSeq <= appliedSeq;
      resyncAfterQueue = false;
      if (html && !failed && lastSeq > appliedSeq) {
        appliedSeq = lastSeq;
        applySectionHtml(html, { announce: !needsResync });
        syncHeaderCount(lastCart.item_count);
        refreshUpsell(lastCart);
      }
      if (needsResync) {
        // A failed or section-less response, or a refresh that overlapped
        // the queue (its answer may predate the final POST): drop any such
        // in-flight refresh and resync once from the server, sent after
        // every POST, so the drawer ends on the cart's real state.
        appliedSeq = requestSeq;
        await refreshCartDrawer({ announce: true });
      }
    }

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-dialog-open="cart-drawer"]')) {
        refreshCartDrawer();
        return;
      }

      const incBtn = event.target.closest('[data-qty-increase]');
      const decBtn = event.target.closest('[data-qty-decrease]');
      const bumpBtn = incBtn || decBtn;
      if (!bumpBtn || !dialog.contains(bumpBtn)) return;

      const lineKey = bumpBtn.dataset.lineKey;
      const line = bumpBtn.closest('[data-cart-line]');
      const qtyEl = line && line.querySelector('[data-qty-value]');
      const currentQty = targets.has(lineKey) ? targets.get(lineKey) : parseInt(qtyEl ? qtyEl.textContent : '0', 10) || 0;
      const nextQty = incBtn ? currentQty + 1 : Math.max(0, currentQty - 1);
      if (nextQty === currentQty) return;

      clearError();
      targets.set(lineKey, nextQty);
      if (qtyEl) qtyEl.textContent = nextQty;
      if (line) line.classList.add('is-pending');
      runQueue();
    });

    document.addEventListener('cart:refresh', (event) => {
      clearError();
      refreshCartDrawer({ open: !!(event.detail && event.detail.open) });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  class CollectionView extends HTMLElement {
    connectedCallback() {
      const stored = this.readDensity();
      if (stored) {
        this.dataset.cols = stored;
      }
      this.updateSwatches();

      this.querySelectorAll('[data-cols-btn]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.dataset.cols = button.dataset.colsBtn;
          this.writeDensity(button.dataset.colsBtn);
          this.updateSwatches();
        });
      });

      this.filterToggle = this.querySelector('[data-filter-toggle]');
      this.filterPanel = this.querySelector('[data-filter-panel]');
      this.filterToggle?.addEventListener('click', () => {
        const open = this.filterToggle.getAttribute('aria-expanded') !== 'true';
        this.filterToggle.setAttribute('aria-expanded', String(open));
        this.filterPanel?.classList.toggle('is-open', open);
      });

      // Sort select submits its own GET form (which carries the active
      // filters as hidden inputs) as soon as the choice changes.
      this.querySelectorAll('select[data-auto-submit]').forEach((select) => {
        select.addEventListener('change', () => {
          const form = select.form;
          if (!form) return;
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        });
      });
    }

    // Storage can throw (private mode, blocked site data): the density
    // toggle then simply doesn't persist.
    readDensity() {
      try {
        return window.localStorage.getItem('collection-density');
      } catch (error) {
        return null;
      }
    }

    writeDensity(value) {
      try {
        window.localStorage.setItem('collection-density', value);
      } catch (error) {
        /* not persisted */
      }
    }

    updateSwatches() {
      const cols = Number(this.dataset.cols || 3);
      this.querySelectorAll('[data-cols-btn]').forEach((button) => {
        button.classList.toggle('is-filled', cols >= Number(button.dataset.colsBtn));
      });
    }
  }

  if (!customElements.get('collection-view')) {
    customElements.define('collection-view', CollectionView);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-dialog-open]');
    if (opener) {
      if (opener.tagName === 'A') event.preventDefault();
      const dialog = document.getElementById(opener.dataset.dialogOpen);
      if (dialog) window.openDialogAnimated(dialog);
      return;
    }

    const closer = event.target.closest('[data-dialog-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog) window.closeDialogAnimated(dialog);
      return;
    }

    if (event.target.tagName === 'DIALOG' && event.target.open) {
      window.closeDialogAnimated(event.target);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  const PRODUCT_MOBILE_QUERY = '(max-width: 990px)';

  class ProductInfo extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-product-variants]').textContent);
      const pricesScript = this.querySelector('[data-variant-prices]');
      try {
        this.prices = pricesScript ? JSON.parse(pricesScript.textContent) : {};
      } catch (error) {
        this.prices = {};
      }
      this.selected = {};

      this.querySelectorAll('.product-option').forEach((group) => {
        const index = group.dataset.optionIndex;
        const selectedButton = group.querySelector('.is-selected');
        if (selectedButton) this.selected[index] = selectedButton.dataset.optionValue;
      });

      const input = this.querySelector('[data-variant-id-input]');
      const initialId = input ? Number(input.value) : null;
      this.currentVariant = this.variants.find((variant) => variant.id === initialId) || null;

      this.addButton = this.querySelector('[data-add-to-cart]');
      this.addLabel = this.querySelector('[data-add-to-cart-label]');
      this.errorRegion = this.querySelector('[data-form-error]');

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-option-value]');
        if (button) {
          event.preventDefault();
          this.selectOption(button);
        }
      });

      const form = this.querySelector('form');
      if (form) {
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.addToCart(form);
        });
      }

      this.initStickyBar();
    }

    disconnectedCallback() {
      if (this.stickyObserver) this.stickyObserver.disconnect();
      if (this.buttonObserver) this.buttonObserver.disconnect();
      if (this.mediaQuery && this.onMediaChange) this.mediaQuery.removeEventListener('change', this.onMediaChange);
      document.body.classList.remove('has-sticky-atc');
    }

    selectOption(button) {
      const index = button.dataset.optionIndex;
      const group = button.closest('.product-option');
      this.selected[index] = button.dataset.optionValue;

      group.querySelectorAll('[data-option-value]').forEach((el) => {
        el.classList.toggle('is-selected', el === button);
      });
      const label = group.querySelector('[data-option-value-label]');
      if (label) label.textContent = button.dataset.optionValue;

      const match = this.variants.find((variant) =>
        variant.options.every((value, i) => this.selected[i] === undefined || this.selected[i] === value)
      );

      this.updateVariant(match);
      this.showError('');
      if (match) {
        this.updateUrl(match);
        this.showVariantImage(match);
      }
    }

    updateVariant(variant) {
      this.currentVariant = variant || null;
      const input = this.querySelector('[data-variant-id-input]');
      const addButton = this.addButton;
      const label = this.addLabel;
      const availability = this.querySelector('[data-availability]');
      const availabilityText = this.querySelector('[data-availability-text]');

      if (!variant) {
        if (input) input.value = '';
        if (addButton) addButton.disabled = true;
        if (label) label.textContent = this.dataset.unavailableLabel || 'Unavailable';
        if (availability) availability.setAttribute('data-sold-out', '');
        if (availabilityText) availabilityText.textContent = this.dataset.unavailableLabel || 'Unavailable';
        return;
      }

      if (input) input.value = variant.id;
      if (addButton) addButton.disabled = !variant.available;

      if (label) {
        label.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel;
      }

      if (availability) {
        availability.toggleAttribute('data-sold-out', !variant.available);
      }
      if (availabilityText) {
        availabilityText.textContent = variant.available
          ? this.dataset.lowStockText
          : this.dataset.soldOutLabel;
      }

      this.updatePrice(variant);
    }

    /** Fills the price row, sale badge and instalment line from strings
        pre-formatted server-side with the shop's money format. */
    updatePrice(variant) {
      const price = this.prices[String(variant.id)];
      if (!price) return;

      const now = this.querySelector('[data-price-now]');
      const was = this.querySelector('[data-price-was]');
      const badge = this.querySelector('[data-price-badge]');
      const installment = this.querySelector('[data-installment]');
      const stickyPrice = this.querySelector('[data-sticky-price]');

      if (now) now.textContent = price.price;
      if (stickyPrice) stickyPrice.textContent = price.price;
      if (was) {
        was.textContent = price.compare || '';
        was.hidden = !price.compare;
      }
      if (badge) {
        badge.textContent = price.badge || '';
        badge.hidden = !price.badge;
      }
      if (installment) installment.textContent = price.installment;

      const progress = this.querySelector('.product-gallery__progress');
      if (progress) progress.classList.toggle('product-gallery__progress--sale', Boolean(price.compare));
    }

    updateUrl(variant) {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (error) {
        // History API unavailable (e.g. sandboxed frame); the form still works.
      }
    }

    showVariantImage(variant) {
      const imageId = variant.featured_image && variant.featured_image.id;
      const gallery = this.querySelector('product-gallery');
      if (imageId && gallery && typeof gallery.showImageId === 'function') gallery.showImageId(imageId);
    }

    showError(message) {
      if (this.errorRegion) this.errorRegion.textContent = message || '';
    }

    cartAddUrl() {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return `${root.endsWith('/') ? root : `${root}/`}cart/add.js`;
    }

    async addToCart(form) {
      const addButton = this.addButton;
      const label = this.addLabel;
      if (!addButton || addButton.disabled) return;
      const formData = new FormData(form);

      addButton.disabled = true;
      this.showError('');

      try {
        const response = await fetch(this.cartAddUrl(), {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        });

        if (response.ok) {
          if (label) label.textContent = this.dataset.addedLabel;
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          // Restore from the current variant rather than blindly re-enabling,
          // so a variant that sold out (or was switched to one) stays disabled.
          setTimeout(() => this.updateVariant(this.currentVariant), 1800);
          return;
        }

        let message = this.dataset.errorLabel;
        try {
          const data = await response.json();
          if (data && (data.description || data.message)) message = data.description || data.message;
        } catch (parseError) {
          // Non-JSON error body: keep the generic message.
        }
        this.updateVariant(this.currentVariant);
        this.showError(message);
      } catch (error) {
        this.updateVariant(this.currentVariant);
        this.showError(this.dataset.errorLabel);
      }
    }

    /** Mobile/tablet: fixed bottom bar that appears once the main button has
        scrolled above the viewport. It mirrors the main button's state. */
    initStickyBar() {
      this.stickyBar = this.querySelector('[data-sticky-atc]');
      this.stickyButton = this.querySelector('[data-sticky-atc-button]');
      if (!this.stickyBar || !this.stickyButton || !this.addButton) return;

      this.stickyButton.addEventListener('click', () => {
        if (!this.addButton.disabled) this.addButton.click();
      });

      const sync = () => {
        this.stickyButton.disabled = this.addButton.disabled;
        if (this.addLabel) this.stickyButton.textContent = this.addLabel.textContent.trim();
      };
      this.buttonObserver = new MutationObserver(sync);
      this.buttonObserver.observe(this.addButton, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        characterData: true,
        subtree: true,
      });
      sync();

      this.mediaQuery = window.matchMedia(PRODUCT_MOBILE_QUERY);
      this.mainButtonAbove = false;
      this.onMediaChange = () => this.setStickyVisible(this.mediaQuery.matches && this.mainButtonAbove);
      this.mediaQuery.addEventListener('change', this.onMediaChange);

      if ('IntersectionObserver' in window) {
        this.stickyObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.mainButtonAbove = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            this.setStickyVisible(this.mediaQuery.matches && this.mainButtonAbove);
          });
        });
        this.stickyObserver.observe(this.addButton);
      }
    }

    setStickyVisible(visible) {
      const bar = this.stickyBar;
      if (!bar || bar.classList.contains('is-visible') === visible) return;

      if (visible) {
        bar.removeAttribute('inert');
        bar.setAttribute('aria-hidden', 'false');
        // Commit the off-screen state before adding the class so the slide-in
        // always transitions (forced reflow instead of a frame callback).
        void bar.offsetHeight;
        bar.classList.add('is-visible');
        document.body.classList.add('has-sticky-atc');
      } else {
        // Inert would drop focus to <body>; hand it to the main button (or,
        // if that is disabled, the product title) without jumping the page.
        if (bar.contains(document.activeElement)) {
          let target = this.addButton;
          if (!target || target.disabled) {
            target = this.querySelector('.product-info-panel__title');
            if (target && !target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
          }
          if (target) target.focus({ preventScroll: true });
        }
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
        bar.setAttribute('inert', '');
        document.body.classList.remove('has-sticky-atc');
      }
    }
  }

  customElements.define('product-info', ProductInfo);

  /** Desktop: thumbnail rail (hover/focus/click to swap), prev/next arrows,
      bounded rail with scroll buttons. Mobile/tablet: a native scroll-snap
      carousel whose position drives the counter/pager. All breakpoints:
      clicking an image opens a full-screen lightbox with keyboard, swipe
      and 2x zoom. */
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.count = this.slides.length;
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.rail = this.querySelector('[data-gallery-rail]');
      this.scroller = this.querySelector('[data-gallery-thumbs]');
      this.railUp = this.querySelector('[data-thumbs-scroll="-1"]');
      this.railDown = this.querySelector('[data-thumbs-scroll="1"]');
      this.currentLabel = this.querySelector('[data-gallery-current]');
      this.track = this.querySelector('[data-gallery-track]');
      this.dots = Array.from(this.querySelectorAll('[data-gallery-dot]'));
      this.progress = this.querySelector('[data-gallery-progress]');
      this.mediaQuery = window.matchMedia(PRODUCT_MOBILE_QUERY);

      // Hover/focus only swap the image; they never scroll the rail.
      this.thumbs.forEach((thumb, i) => {
        thumb.addEventListener('mouseenter', () => this.setIndex(i));
        thumb.addEventListener('focus', () => this.setIndex(i));
      });

      this.addEventListener('click', (event) => this.onClick(event));
      this.addEventListener('keydown', (event) => this.onKeydown(event));

      if (this.rail && this.scroller) {
        this.scroller.addEventListener('scroll', () => this.updateRail(), { passive: true });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateRail());
          this.resizeObserver.observe(this.scroller);
        }
        this.updateRail();
      }

      if (this.track) {
        this.track.addEventListener('scroll', () => this.onTrackScroll(), { passive: true });
        this.track.addEventListener('pointerdown', (event) => {
          this.trackPointer = { x: event.clientX, y: event.clientY };
        });
      }

      this.onMediaChange = () => this.syncMode();
      this.mediaQuery.addEventListener('change', this.onMediaChange);
      this.syncMode();

      this.lightbox = this.querySelector('[data-lightbox]');
      if (this.lightbox) this.initLightbox();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.mediaQuery && this.onMediaChange) this.mediaQuery.removeEventListener('change', this.onMediaChange);
    }

    isMobile() {
      return this.mediaQuery.matches;
    }

    /** Carousel semantics only exist while the track is a carousel. */
    syncMode() {
      if (!this.track) return;
      if (this.isMobile()) {
        this.track.setAttribute('role', 'region');
        this.track.setAttribute('aria-roledescription', 'carousel');
        this.track.setAttribute('tabindex', '0');
        if (this.track.dataset.carouselLabel) this.track.setAttribute('aria-label', this.track.dataset.carouselLabel);
        this.scrollTrackTo(this.index, 'instant');
      } else {
        // A bare aria-label on a role-less div is ignored/invalid; only label the region.
        this.track.removeAttribute('role');
        this.track.removeAttribute('aria-roledescription');
        this.track.removeAttribute('tabindex');
        this.track.removeAttribute('aria-label');
      }
    }

    onTrackScroll() {
      if (!this.isMobile() || !this.count) return;
      const width = this.track.clientWidth;
      if (!width) return;
      const index = Math.min(this.count - 1, Math.max(0, Math.round(this.track.scrollLeft / width)));
      if (index !== this.index) this.setIndex(index, { fromScroll: true });
    }

    scrollTrackTo(index, behavior) {
      if (!this.track || !this.isMobile()) return;
      const left = index * this.track.clientWidth;
      if (Math.abs(this.track.scrollLeft - left) < 1) return;
      this.track.scrollTo({ left, behavior: behavior || 'smooth' });
    }

    onClick(event) {
      // The lightbox lives inside this element; it has its own handlers.
      if (this.lightbox && this.lightbox.contains(event.target)) return;

      const thumb = event.target.closest('[data-gallery-thumb]');
      if (thumb) {
        event.preventDefault();
        this.setIndex(this.thumbs.indexOf(thumb));
        return;
      }

      const railButton = event.target.closest('[data-thumbs-scroll]');
      if (railButton) {
        this.scrollRail(Number(railButton.dataset.thumbsScroll));
        return;
      }

      const stepButton = event.target.closest('[data-gallery-step]');
      if (stepButton) {
        this.step(Number(stepButton.dataset.galleryStep));
        return;
      }

      const zoomButton = event.target.closest('[data-gallery-zoom]');
      if (zoomButton && this.lightbox) {
        // A horizontal drag on the carousel must never open the viewer.
        const start = this.trackPointer;
        this.trackPointer = null;
        if (start && event.detail > 0 && Math.abs(event.clientX - start.x) > 10) return;
        this.openLightbox(Number(zoomButton.dataset.galleryZoom), zoomButton);
      }
    }

    onKeydown(event) {
      if (this.lightbox && this.lightbox.contains(event.target)) return;
      if (this.count < 2) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      // Mobile/tablet: only the focused carousel itself pages with the arrow
      // keys; everywhere else in the gallery the keys are left alone.
      if (this.isMobile() && event.target !== this.track) return;
      event.preventDefault();
      this.step(event.key === 'ArrowLeft' ? -1 : 1);
    }

    setIndex(i, { scrollThumb = false, fromScroll = false, behavior = 'smooth' } = {}) {
      if (!this.count) return;
      const index = ((i % this.count) + this.count) % this.count;
      this.index = index;

      // Always clear every state before assigning, so a stale class can
      // never survive alongside the new one.
      this.thumbs.forEach((thumb) => {
        thumb.classList.remove('is-active');
        thumb.removeAttribute('aria-current');
      });
      this.slides.forEach((slide) => slide.classList.remove('is-active'));
      this.dots.forEach((dot) => dot.classList.remove('is-active'));

      const thumb = this.thumbs[index];
      if (thumb) {
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-current', 'true');
      }
      if (this.slides[index]) this.slides[index].classList.add('is-active');
      if (this.dots[index]) this.dots[index].classList.add('is-active');
      if (this.progress) this.progress.style.width = `${((index + 1) / this.count) * 100}%`;
      if (this.currentLabel) this.currentLabel.textContent = index + 1;

      if (scrollThumb) this.revealThumb(thumb);
      if (!fromScroll) this.scrollTrackTo(index, behavior);
    }

    step(delta) {
      if (this.isMobile()) {
        // A scroller has ends; wrapping would rewind through every slide.
        const target = Math.min(this.count - 1, Math.max(0, this.index + delta));
        this.setIndex(target);
        return;
      }
      this.setIndex(this.index + delta, { scrollThumb: true });
    }

    /** Used by the variant picker to jump to a variant's featured image. */
    showImageId(imageId) {
      const index = this.slides.findIndex((slide) => slide.dataset.imageId === String(imageId));
      if (index > -1) this.setIndex(index, { scrollThumb: true });
    }

    /** Scroll only the rail (never the page, unlike scrollIntoView) so the
        active thumb is fully visible. */
    revealThumb(thumb) {
      if (!thumb || !this.scroller || !this.rail.classList.contains('is-scrollable')) return;
      const top = thumb.offsetTop;
      const bottom = top + thumb.offsetHeight;
      const viewTop = this.scroller.scrollTop;
      const viewHeight = this.scroller.clientHeight;

      if (top < viewTop) {
        this.scroller.scrollTo({ top, behavior: 'smooth' });
      } else if (bottom > viewTop + viewHeight) {
        this.scroller.scrollTo({ top: bottom - viewHeight, behavior: 'smooth' });
      }
    }

    scrollRail(direction) {
      const thumbStep = this.thumbs[1] ? this.thumbs[1].offsetTop - this.thumbs[0].offsetTop : 0;
      const amount = Math.max(this.scroller.clientHeight - thumbStep, thumbStep);
      this.scroller.scrollBy({ top: direction * amount, behavior: 'smooth' });
    }

    updateRail() {
      // Compare against the whole rail, not the (inset) scroller, so
      // toggling the buttons can't flip the result back and forth.
      const scrollable = this.scroller.scrollHeight > this.rail.clientHeight + 1;
      this.rail.classList.toggle('is-scrollable', scrollable);

      const maxScroll = this.scroller.scrollHeight - this.scroller.clientHeight;
      if (this.railUp) this.railUp.disabled = !scrollable || this.scroller.scrollTop <= 1;
      if (this.railDown) this.railDown.disabled = !scrollable || this.scroller.scrollTop >= maxScroll - 1;
    }

    initLightbox() {
      this.lightboxSlides = Array.from(this.lightbox.querySelectorAll('[data-lightbox-slide]'));
      this.lightboxLabel = this.lightbox.querySelector('[data-lightbox-current]');
      this.lightboxIndex = 0;
      this.suppressClickUntil = 0;

      this.lightbox.addEventListener('click', (event) => {
        // A swipe that ends over empty space would otherwise register as a
        // backdrop click and close the viewer.
        if (Date.now() < this.suppressClickUntil) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        const stepButton = event.target.closest('[data-lightbox-step]');
        if (stepButton) {
          this.lightboxStep(Number(stepButton.dataset.lightboxStep));
          return;
        }

        const image = event.target.closest('.product-lightbox__image');
        if (image) this.toggleZoom(image, event);
      });

      this.lightbox.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        event.stopPropagation();
        this.lightboxStep(event.key === 'ArrowLeft' ? -1 : 1);
      });

      this.lightbox.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.swipeStart = { x: event.clientX, y: event.clientY };
      });

      this.lightbox.addEventListener('pointermove', (event) => {
        if (this.zoomedImage) this.setZoomOrigin(event.clientX, event.clientY);
      });

      this.lightbox.addEventListener('pointerup', (event) => {
        const start = this.swipeStart;
        this.swipeStart = null;
        if (!start || this.zoomedImage) return;
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          this.suppressClickUntil = Date.now() + 400;
          this.lightboxStep(dx < 0 ? 1 : -1);
        }
      });

      this.lightbox.addEventListener('pointercancel', () => {
        this.swipeStart = null;
      });

      this.lightbox.addEventListener('close', () => {
        this.resetZoom();
        document.documentElement.style.overflow = '';
        this.setIndex(this.lightboxIndex, { scrollThumb: true, behavior: 'instant' });

        const zoomButton = this.querySelector(`[data-gallery-zoom="${this.index}"]`) || this.lightboxTrigger;
        if (zoomButton) zoomButton.focus({ preventScroll: true });
      });
    }

    openLightbox(index, trigger) {
      this.lightboxTrigger = trigger;
      this.showLightboxSlide(index);
      document.documentElement.style.overflow = 'hidden';
      window.openDialogAnimated(this.lightbox);
    }

    showLightboxSlide(i) {
      const count = this.lightboxSlides.length;
      if (!count) return;
      const index = ((i % count) + count) % count;
      this.lightboxIndex = index;
      this.resetZoom();

      // Hidden slides are display:none, so their lazy images never load.
      this.lightboxSlides.forEach((slide) => {
        slide.hidden = true;
      });
      this.lightboxSlides[index].hidden = false;
      if (this.lightboxLabel) this.lightboxLabel.textContent = index + 1;
    }

    lightboxStep(delta) {
      this.showLightboxSlide(this.lightboxIndex + delta);
    }

    toggleZoom(image, event) {
      if (image.classList.contains('is-zoomed')) {
        this.resetZoom();
        return;
      }
      // Measure before scaling; panning maps the pointer against this
      // unscaled box so the zoomed image follows the cursor.
      this.zoomRect = image.getBoundingClientRect();
      this.zoomedImage = image;
      this.setZoomOrigin(event.clientX, event.clientY);
      image.classList.add('is-zoomed');
    }

    setZoomOrigin(clientX, clientY) {
      const rect = this.zoomRect;
      if (!rect || !this.zoomedImage || !rect.width || !rect.height) return;
      const x = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
      const y = Math.min(100, Math.max(0, ((clientY - rect.top) / rect.height) * 100));
      this.zoomedImage.style.transformOrigin = `${x}% ${y}%`;
    }

    resetZoom() {
      if (this.zoomedImage) this.zoomedImage.classList.remove('is-zoomed');
      this.zoomedImage = null;
      this.zoomRect = null;
    }
  }

  customElements.define('product-gallery', ProductGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              window.initScrollReveal && window.initScrollReveal(this);
            }
          })
          .catch(() => {});
      };

      new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
